import { CancelActionContext } from "./CancelActionContext";
import useCancel from "./useCancel";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import usePrepareCancel from "./usePrepareCancel";
import { EditActionContext } from "../edit/EditActionContext";

function useCancelAction(modelConfig: any, index: any): any {
  const prepareCancel = usePrepareCancel();
  const prepareCancelFunction = (id: any) => prepareCancel(id);

  const {element, setElement} = useContext(EditActionContext)

  const onSuccessCancel = () => {
    setShowModal(false);
    index();
    if (element) {
      setElement({ ...element, cancelled: true });
    }
  };

  const cancel = useCancel(modelConfig);

  const cancelFunction = () => cancel(onSuccessCancel);

  const contextInstance = useContext(CancelActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "cancel",
    onSubmit: () => cancelFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t(`are_you_sure_you_want_to_cancel_this_${modelConfig.modelName}?`)}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareCancelFunction,
    actionTemplate,
  };
}

export default useCancelAction;
